/**
 * @generated SignedSource<<a90f247752f0d24abbbbeef5b720b848>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFacilityLessonNoun_facility$data = {
  readonly copyOverrides: {
    readonly lesson: {
      readonly plural: string;
      readonly singular: string;
    } | null | undefined;
  };
  readonly " $fragmentType": "useFacilityLessonNoun_facility";
};
export type useFacilityLessonNoun_facility$key = {
  readonly " $data"?: useFacilityLessonNoun_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityLessonNoun_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityLessonNoun_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityCopyOverrides",
      "kind": "LinkedField",
      "name": "copyOverrides",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NounOverride",
          "kind": "LinkedField",
          "name": "lesson",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plural",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "singular",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "12b707c24efd2eaef53f9949bcf41974";

export default node;
